/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { formatBytes } from 'ng/shared/utils/math.utils';
import './upload-status.less';
import * as l10n from './uploadStatus.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;
/**
 * @ngdoc component
 * @name  uploadStatus
 * @param  {upload} Instance of Upload factory.
 * @description Used to display the status of the upload in progress.
 */

class UploadStatusController {
    constructor(l10nService) {
        this.l10nKeys = l10nKeys;

        l10nService.registerSourceBundles(dictionary);

        /**
         * Returns a formatted string of loaded bytes to total bytes. ex. '10KB of 50KB'.
         * @return {string} [description]
         */
        this.getProgressBytes = function() {
            const { uploadStatus } = this.upload;

            return l10nService.getMessage(l10nKeys.progressBytesPercentage,
                [formatBytes(uploadStatus.loaded), formatBytes(uploadStatus.total)]);
        };
    }
}

UploadStatusController.$inject = [
    'l10nService',
];

angular.module('aviApp').component('uploadStatus', {
    bindings: {
        upload: '<',
    },
    controller: UploadStatusController,
    templateUrl: 'src/components/common/upload-status/upload-status.html',
});
